import { useCallback, useEffect, useState } from 'react';

import { getApvCounters } from '@app/crud/customers/customer.crud';
import type { ApvCounters } from '@app/crud/customers/customer.type';

interface UseApvCountersReturn {
    counters: ApvCounters | null;
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<void>;
}

export const useApvCounters = (autoFetch = true): UseApvCountersReturn => {
    const [counters, setCounters] = useState<ApvCounters | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | null>(null);

    const fetchCounters = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await getApvCounters();
            setCounters(result);
        } catch {
            setError(new Error('Failed to fetch APV counters'));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (autoFetch) {
            fetchCounters();
        }
    }, [autoFetch, fetchCounters]);

    return {
        counters,
        loading,
        error,
        refetch: fetchCounters,
    };
};

export default useApvCounters;
